import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      openid: 'taogeniubi'
    },
    position: {
      lat: 30.297108,
      lng: 120.089626,
      // lat: '',
      // lng: ''
    }
  },
  mutations: {},
  actions: {},
  modules: {}
})
